import { createFileRoute } from "@tanstack/react-router";

import ReportingPage from "@/components/[routes]/reporting/reporting-page";

export const Route = createFileRoute("/_secure/reporting")({
  component: ReportingPage,
});
